/**
 * Setup-screen defaults (pure; the DOM wiring is in menu.ts).
 *
 * The team controls are two counts — Teams and Bot Teams — plus two unit counts
 * — Units/Team and Bot Units. Left alone they drifted into states nobody asked
 * for: adding a team added a *human* team, and bot units stayed at 1 while the
 * human side went to 3, so "me against three bot squads" came out as three
 * human teams of three and one lone bot. These rules keep the common intent:
 *   - changing the number of teams changes the number of bot teams; the human
 *     teams you already have stay as they are (a new team is a bot team);
 *   - Bot Units follows Units/Team until the player sets Bot Units by hand, so a
 *     bot team is a full team of bots by default.
 */

/** New bot-team count after Teams changes from `prevTeams` to `newTeams`: human teams are preserved, bots absorb the change. */
export function botTeamsAfterTeamCountChange(prevTeams: number, prevBotTeams: number, newTeams: number): number {
  const humans = Math.max(0, prevTeams - prevBotTeams);
  return Math.max(0, Math.min(newTeams, newTeams - humans));
}

/** Bot Units mirrors Units/Team unless the player has touched Bot Units themselves. */
export function botUnitsAfterUnitsChange(newUnitsPerTeam: number, currentBotUnits: number, botUnitsTouched: boolean): number {
  return botUnitsTouched ? currentBotUnits : newUnitsPerTeam;
}
